import type { SiteSettings } from "@client/api-services/client";
import { Facebook, Instagram, PaperPlane, Youtube, Twitter } from "~/components/icons";
import { LangLink } from "~/components/common/LangLink";
import { getLogoAssets, getFooterLogoAssets } from "~/services/site-assets";
import { useTranslation } from "react-i18next";

export function Footer({ siteId, selfSettings }: { siteId: number, selfSettings: SiteSettings["selfSettings"] }) {
	const logo = getLogoAssets(siteId);
	const { t } = useTranslation();
	const footerLogo = getFooterLogoAssets(siteId);
	const aboutUrl = selfSettings?.aboutUrl;
	const faqUrl = selfSettings?.faqUrl;
	const privacyPolicyUrl = selfSettings?.privacyPolicyUrl || "/privacy-policy";
	const refundPolicyUrl = selfSettings?.refundPolicyUrl || "/refund-policy";
	const termsAndConditionsUrl = selfSettings?.termsAndConditionsUrl || "/terms-and-conditions";
	const facebookUrl = selfSettings?.facebookUrl;
	const youtubeUrl = selfSettings?.youtubeUrl;
	const instagramUrl = selfSettings?.instagramUrl;
	const twitterUrl = selfSettings?.twitterUrl;
	return <>
		<div className="grid grid-cols-1 lg:grid-cols-[fit-content(300px)_1fr] items-center">
			<LangLink to="/" className="mr-auto mb-4 lg:mb-0">
				<img className="footer-logo-main" src={footerLogo} alt="eTopupOnline.com" />
			</LangLink>
			<div className="grid grid-cols-1 lg:grid-flow-col lg:auto-cols-max lg:gap-5 lg:justify-end lg:justify-items-end items-center">
				<LangLink to="/contact-us" className="py-2" >
					<h2 className="footer-item">{t("footer.contact_us")}</h2>
				</LangLink>
				{faqUrl ? <LangLink target="_blank" rel="noreferrer" to={faqUrl} className="py-2">
					<h3 className="footer-item">{t("common.faq")}</h3>
				</LangLink> : null}
				{aboutUrl ? <LangLink target="_blank" rel="noreferrer" to={aboutUrl} className="py-2">
					<h3 className="footer-item">{t("footer.about_us")}</h3>
				</LangLink> : null}
				<LangLink target="_blank" rel="noreferrer" to={privacyPolicyUrl} className="py-2">
					<span className="footer-item">{t("footer.privacy_policy")}</span>
				</LangLink>
				<LangLink target="_blank" rel="noreferrer" to={refundPolicyUrl} className="py-2">
					<span className="footer-item">{t("footer.refund_policy")}</span>
				</LangLink>
				<LangLink target="_blank" rel="noreferrer" to={termsAndConditionsUrl} className="py-2">
					<h2 className="footer-item">{t("common.tnc")}</h2>
				</LangLink>
			</div>
		</div>
		<div className="lg:flex flex-row-reverse items-center justify-between mt-6">
			<div className="flex-1 flex items-center lg:justify-end gap-2 mb-4 lg:mb-0">
				{facebookUrl ? <a target="_blank" rel="noreferrer" href={facebookUrl} className="bg-red-600/10 size-12 rounded-full flex items-center justify-center">
					<Facebook className="size-5 text-red-600" />
				</a> : null}
				{youtubeUrl ? <a target="_blank" rel="noreferrer" href={youtubeUrl} className="bg-red-600/10 size-12 rounded-full flex items-center justify-center">
					<Youtube className="size-5 text-red-600" />
				</a> : null}
				{twitterUrl ? <a target="_blank" rel="noreferrer" href={twitterUrl} className="bg-red-600/10 size-12 rounded-full flex items-center justify-center">
					<Twitter className="size-5 text-red-600" />
				</a> : null}
				{instagramUrl ? <a target="_blank" rel="noreferrer" href={instagramUrl} className="bg-red-600/10 size-12 rounded-full flex items-center justify-center">
					<Instagram className="size-5 text-red-600" />
				</a> : null}
			</div>
			<div className="text-base font-normal text-slate-700/60">
				Copyright © {new Date().getFullYear()} ELEMT Technologies, inc.
			</div>
		</div>
	</>
}